import styled from 'styled-components';
import { CHAT_PANEL_WIDTH } from '~/components/CelsiusAIChat/styles';

export const PrivateRouteWrapper = styled.div<{ isMenuOpen: boolean, isCelsiusOpen: boolean, isRemoteControl: boolean, path?: string }>(
  ({
    isMenuOpen, isCelsiusOpen, isRemoteControl, path,
  }) => `
  padding: ${isRemoteControl ? '0px' : '24px 16px'};
  @media (min-width: 768px) {
    padding-top: 70px;
    padding-left: ${isMenuOpen ? '270px' : '75px'};
    padding-right: ${isCelsiusOpen ? `${CHAT_PANEL_WIDTH + 20}px` : '20px'};
    transition: padding-right 0.25s ease;
  }

  ${handlePaddingOverview(isMenuOpen, isCelsiusOpen, path)}
`,
);

function handlePaddingOverview(isMenuOpen: boolean, isCelsiusOpen: boolean, path?: string): string {
  if (path !== '/nova-visao-geral') return '';

  const paddingLeft = isMenuOpen ? '260' : '70';
  const paddingRight = isCelsiusOpen ? `${CHAT_PANEL_WIDTH}px` : '0px';

  return `
    padding: 0px;

    @media (min-width: 768px) {
      padding: 0px;
      padding-top: 70px;
      padding-left: ${paddingLeft}px;
      padding-right: ${paddingRight};
      transition: padding-right 0.25s ease;
    }

    @media (max-width: 768px) {
      padding-top: 20px;
    }
  `;
}
